import { IconType, LinkProps, LinkTarget } from '@atlassian/learning-components';
import React from 'react';

import { AssociatedContent as AssociatedContentItem } from 'src/graphql/generated/graphql';

import SimpleContentBlock from './SimpleContentBlock';

const AssociatedContent: React.FC<{
  associatedContent: AssociatedContentItem;
}> = ({ associatedContent }) => {
  if (associatedContent.__typename === 'AssociatedContent') {
    const linkProps: LinkProps = {
      link: associatedContent.link?.link,
      target: associatedContent.link?.target as LinkTarget,
      label: associatedContent.link?.label,
      icon: (associatedContent.link?.icon as unknown as IconType) ?? 'arrow-right',
    };

    return (
      <SimpleContentBlock
        // @ts-expect-error - fields are renamed to title in the graphql schema
        title={associatedContent.title}
        description={associatedContent.description}
        imageUrl={associatedContent.asset?.cdnUrl ?? associatedContent.asset?.image?.url}
        imageAlt={associatedContent.asset?.altText}
        link={linkProps}
      />
    );
  }

  return null;
};

export default AssociatedContent;
